import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function News({ data }) {
    const [previousNewsPage, setPreviousNewsPage] = useState();

    const showOrHideNewsPage = (pageNumber, show) => {
        let pageToShow = document.getElementsByClassName("news_page_" + pageNumber);
        for (let i = 0; i < pageToShow.length; i++) {
            if (show) {
                pageToShow[i].style.display = "block";
                pageToShow[i].parentNode.style.display = "block";
            } else {
                pageToShow[i].style.display = "none";
                pageToShow[i].parentNode.style.display = "none";
            }
        }
    };

    const switchNewsPage = (pageNumber) => {
        if (previousNewsPage) {
            if (pageNumber === previousNewsPage) {
                return false;
            }
            showOrHideNewsPage(previousNewsPage, false);
            showOrHideNewsPage(pageNumber, true);
        } else {
            showOrHideNewsPage(pageNumber, true);
            window.jQuery("#newsPager_" + pageNumber).addClass("active_page");
        }
        if (window.jQuery("#newsPager_" + previousNewsPage).hasClass("active_page")) {
            window.jQuery("#newsPager_" + previousNewsPage).removeClass("active_page");
            window.jQuery("#newsPager_" + pageNumber).addClass("active_page");
        }
        setPreviousNewsPage(pageNumber);
    };

    const switchNewsPageAndSuppressEvent = (e, pageNumber) => {
        e.preventDefault();
        switchNewsPage(pageNumber);
    };

    useEffect(() => {
        // Ensure jQuery is loaded before using it
        if (window.jQuery) {
            window.jQuery(document).ready(function() {
                switchNewsPage(1);
            });
        }
    }, []);

    const pageListElements = [];
    for (let i = 1; i < Math.ceil( data.newsLinks.length / 8 ) + 1; i++) {
        pageListElements.push(
            <li key={ i } className="page-item">
                <a href="" onClick={ (e) => switchNewsPageAndSuppressEvent(e, i) } className="page-link" id={ "newsPager_" + i }>{ i }</a>
            </li>
        );
    }

    const newsLinkElements = [];
    const newsLinkColumnSize = 4;
    const newsLinkPageSize = 8;
    for (let i = 0; i < data.newsLinks.length; i += newsLinkColumnSize) {
        const chunk = data.newsLinks.slice(i, i + newsLinkColumnSize);
        newsLinkElements.push(
            <div key={ i / newsLinkColumnSize } className="col-sm-6 col-xs-12 no-padding" style={{ display: "none" }}>
                {chunk.map((newsLink, newsLinkIdx) => (
                    <div key={ newsLinkIdx } className={ "news-headline news_page_" + Math.ceil( ((i + 1) + newsLinkIdx) / newsLinkPageSize ) }>
                        <p className="body-text" style={{ maxWidth: "550px" }}>
                            { newsLink.headline }
                        </p>

                        <div className="body-text">
                            {/* The "T00:00:00" is needed to prevent timezone conversion using the current time.  Otherwise it is possible at certain times of the day that the dates will be behind by 1 day. */}
                            { new Date(newsLink.date + "T00:00:00").toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'}) } &nbsp; | &nbsp; <a href={ newsLink.link.url } target="_blank" className="body-text light-blue-text">{ newsLink.link.label }</a>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div key={data.documentId} className="news" style={{width: '100%'}}>
            <div className="views-row views-row-4 views-row-even">

                    <div className="container-fluid news-container" id="latestNews" style={{ maxWidth: "1320px" }}>
                        <div className="row">

                            <div className="col-sm-12 no-padding">
                                <span className="section-headline-small pull-left">
                                    LATEST NEWS
                                </span>

                                <span className="pull-right">
                                    <nav aria-label="Page navigation">
                                        <ul className="pagination" style={{ margin: "0" }}>
                                            { pageListElements }
                                        </ul>
                                    </nav>
                                </span>

                            </div>
                        </div>

                        <div className="row">
                            <div>
                                <hr style={{ borderTop: "2px solid #333" }} />
                            </div>

                            <div className={'news-container-flex'} >
                                { newsLinkElements }
                            </div>

                        </div>

                    </div>

            </div>
        </div>
    );
}

export default News;
